import { IOfferType } from '../../types/offerTypeList';
import { EDealType } from '../../utils/jsonQuery';
import { OFFER_TYPES } from '../../constants/filters/offerTypes/offerTypes';

export function getOfferTypeList(dealType: EDealType): IOfferType[][] {
  return OFFER_TYPES.find(type => type.dealType === dealType)?.list || [];
}
